import React from 'react';
import ProfileContainer from 'containers/ProfileContainer';

type Props = {};

export default function ProfilePage({}: Props) {
  return <ProfileContainer />;
}
